import { cn } from "@bentolabs/kit/utils";
import { Popover as RadixPopover } from "radix-ui";

export const Popover = (props: RadixPopover.PopoverProps) => {
  return <RadixPopover.Root {...props} />;
};

const PopoverContent = ({
  children,
  className,
  ...props
}: RadixPopover.PopoverContentProps) => {
  return (
    <RadixPopover.Content
      {...props}
      style={{
        boxShadow:
          "0px 12px 34.5px 0px #0000004D, 0px 1px 1px 0px #FFFFFF1A inset",
      }}
      className={cn(
        "PopoverContent",
        "bg-[#1C1C1C] outline-hidden backdrop-blur-[220px]",
        "flex flex-col rounded-[18px] px-2.5 py-3.5",
        className
      )}
    >
      {children}
    </RadixPopover.Content>
  );
};

Popover.Portal = RadixPopover.Portal;
Popover.Trigger = RadixPopover.Trigger;
Popover.Content = PopoverContent;
Popover.Close = RadixPopover.Close;
